// @ts-nocheck

(() => {
  const selector = '[data-wardrobe-owner-block-2]';

  const initialize = (scope = document) => {
    scope.querySelectorAll(selector).forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      requestAnimationFrame(() => {
        section.classList.add('is-ready');
      });
    });
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
